import { useQuery } from '@tanstack/react-query';
import { GetXToken } from '../../../api/marketing';
import { SocialPostModal } from '../../../components/Modals/SocialMedia';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../../store/pages/forms/store';
import { useMatch } from 'react-router-dom';

const XCallback = () => {
  const [showSocialPost, setShowSocialPost] = useState(false);
  const [wasPageRefreshed, setPageRefreshed] = useState(false);
  const navigate = useNavigate();
  const setNotificationData = useStore((state) => state.SHOW_NOTIFICATION);

  const redirectUri = sessionStorage.getItem('redirectUri');

  useEffect(() => {
    const navigationEntries = window.performance.getEntriesByType('navigation');
    if (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') {
      console.log('Page was reloaded');
      setPageRefreshed(true);
    }
  }, []);

  if (wasPageRefreshed) {
    console.log('refreshed');
    window.location.href = redirectUri;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const state = urlParams.get('state');
  const authCode = urlParams.get('code');

  const twitterPost = JSON.parse(sessionStorage.getItem('twitterPost'));

  const tokenQuery = useQuery({
    queryKey: ['GetXToken'],
    queryFn: GetXToken(
      [
        { queryParam: 'code', queryVal: authCode },
        { queryParam: 'redirectUri', queryVal: redirectUri },
      ],
      { message: twitterPost?.message }
    ),
    enabled: !!authCode,
  });

  useEffect(() => {
    if (tokenQuery.isSuccess && tokenQuery.data) {
      const response = tokenQuery.data;
      const data = response?.data;

      setShowSocialPost({
        selectedNetwork: 'X',
        ...twitterPost,
        pageOptions: [
          {
            value: data?.id,
            label: data?.name,
            accessToken: response?.access_token,
            pageId: data?.id,
          },
        ],
      });
    }
  }, [tokenQuery.isSuccess, tokenQuery.data]);

  return (
    <>
      <SocialPostModal
        show={showSocialPost}
        setShow={setShowSocialPost}
        setStatus={setNotificationData}
      />
    </>
  );
};

export default XCallback;
